import MD5 from 'js-md5'
import Cookies from 'js-cookie'
const TokenKey = 'koizumi_token'
const UserKey = 'koizumi_user'
const FBTokenKey = 'fb_token'

export function getToken () {
  return Cookies.get(TokenKey)
}
export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  Cookies.remove(TokenKey)
  return removeFBToken()
}

export function getFBToken () {
  return Cookies.get(FBTokenKey)
}

export function setFBToken (token) {
  return Cookies.set(FBTokenKey, token)
}

export function removeFBToken () {
  return Cookies.remove(FBTokenKey)
}

export function getUser () {
  return Cookies.get(UserKey)
}

export function setUser (user) {
  return Cookies.set(UserKey, user)
}

export function removeUser () {
  return Cookies.remove(UserKey)
}

export function getSign (data) {
  const keysSorted = Object.keys(data)
  let str = ''
  for (let i = 0; i < keysSorted.length; i++) {
    if (typeof data[keysSorted[i]] === 'object') {
      str += keysSorted[i] + '=' + (data[keysSorted[i]] !== null ? JSON.stringify(data[keysSorted[i]]) : '')
    } else {
      str += keysSorted[i] + '=' + (data[keysSorted[i]] !== null ? data[keysSorted[i]] : '')
    }
  }

  return MD5(str).toUpperCase()
}



// WEBPACK FOOTER //
// ./src/utils/auth.js